// extracted by css-extract-rspack-plugin
export default {"folders-wrapper":"WSAnRQ","foldersWrapper":"WSAnRQ"};